export default "__VITE_ASSET__CrlOIWAE__"